<template>
    <div class="ortic-form-horizontal">
        <form @submit.prevent="save">
            <o-card :title="$t('sandoz.pass_through_controls')">
                <b-row>
                    <b-col>
                        <o-checkbox :errorField="'verified'" :label="$t('sandoz.verified')" v-model="verified"/>
                        <o-textarea :label="$t('core.note')" v-model="note"></o-textarea>
                        <o-file-upload :label="$t('sandoz.upload')" v-model="file_name" :allow-clear="true"
                                    :allow-download="false">
                        </o-file-upload>
                        <div class="form-group float-right" v-if="file_name">
                            <label></label>
                            <o-button @click.prevent="downloadFile"> 
                                {{ $t('sandoz.download') }}
                            </o-button>
                        </div>
                    </b-col>
                </b-row>
                <o-action-toolbar>
                <div class="d-flex w-100">
                    <o-button variant="outline-primary" @click.prevent="back">{{$t('core.back')}}</o-button>
                    <div class="ml-auto">
                    <o-button variant="primary" :loading="saving" @click.prevent="save">{{$t('core.save')}}</o-button>
                    </div>
                </div>
                </o-action-toolbar>
            </o-card>
        </form>
    </div>
</template>

<script>
  import axios from 'axios'
  import {mapGetters} from 'vuex'
  import { contractYears } from '../../utils/contractYear'

  export default {
    data: () => ({
        consolidateSaleUser: null,
        consolidateSale: null,
        verified: false,
        note: null,
        file_name: null,
        id: 'new',
        saving: false,
        url: null
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    },
    created() {
      this.years = contractYears()
    },
    mounted() {
        this.loadConsolidateSaleUser();
    },
    methods: {
        loadConsolidateSaleUser () {
            axios.get(`/api/consolidate_sales_users/`+this.$route.params.id).then(response => {
                this.consolidateSale = response.data.consolidateSale
                this.consolidateSaleUser = response.data.consolidateSaleUser
                if(response.data.consolidateSaleUser) {
                    this.id =  response.data.consolidateSaleUser.id
                    this.verified = response.data.consolidateSaleUser.verified
                    this.note = response.data.consolidateSaleUser.note
                    this.file_name = response.data.consolidateSaleUser.file_name
                }
            })
        },
        save() {
            this.saving = true
            var data = {
                verified : this.verified,
                note: this.note,
                file_name: this.file_name,
                external_id: this.consolidateSale.external_id,
                id_time: this.consolidateSale.id_time,
                package_eancode: this.consolidateSale.package_eancode
            }

            this.url = `/api/consolidate_sales_users/`+this.id
            axios.post(`/api/consolidate_sales_users/`+this.id, data).then(response => {
                this.saving = false
                this.$notify({
                    title: this.$i18n.t('core.saved'),
                    text: this.$i18n.t('core.saved_text')
                })
            })
        },
        back() {
            this.$router.back()
        },
        downloadFile() {
            var data = {
                file: this.file_name
            }
            axios.post(`/api/consolidate_sales_users/download`, data, { responseType: 'arraybuffer' }).then(response => {
                require('downloadjs')(response.data, this.file_name.name)
            })
        }
    }
  }
</script>
